import { useEffect, useState } from "react";
import RightSideDetails from "../global/rightSideDetails";
import { getUserAll } from "../api/usersAPI";
import swal from 'sweetalert2';
import Select from 'react-select';
import * as helper from '../global/helper';
import { getCoachTaggingAll, postCoachTagging } from "../api/matAPI";

const CoachTagging = (props) => {
    const [coachTagging, setCoachTagging] = useState({});
    const [coachTaggingList, setCoachTaggingList] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [rightSideDetails, setRightSideDetails] = useState(false);
    const [isInit,      setIsInit]               = useState(true);

    useEffect(() => {
        props.title("Coach Tagging", "coach-tagging");
        fetchCoachTagging();
        fetchUsers();
    }, []);

    useEffect(() => {
        if (rightSideDetails) {
            Config.Core.OpenDrawer();
            $('#txtExpiryDate').datepicker({
                format: 'dd-mm-yyyy',
                minDate: new Date(),
            });
            $('#txtExpiryDate').on('change', function (event) {
                updateCoachTaggingDetails('ExpiryDate', moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'))
            });
        } else {
            setCoachTagging({});
        }
    }, [rightSideDetails]);

    useEffect(() => {
        if (!isInit) {
            fillDataTable();
        }
    }, [coachTaggingList]);

    const fetchUsers = async () => {
        try {
            const users = await getUserAll();
            setUsersList(users);
        } catch (error) {
            swal.fire({
                icon: 'error',
                titleText: error.message
            });
        }
    }

    const fetchCoachTagging = async () => {
        try {
            // Fetch the coach tagging data
            const coachTaggingData = await getCoachTaggingAll();
            isInit ? setIsInit(false) : $('#tblCoachTagging').KTDatatable().destroy(); 
            setCoachTaggingList(coachTaggingData);
        } catch (error) {
            swal.fire({
                icon: 'error',
                titleText: error.message
            });
        }
    }

    const fillDataTable = () => {
        const dataTable = $('#tblCoachTagging').KTDatatable({
            data: {
                saveState: false,
                source: coachTaggingList,
                pageSize: 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable: true,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Name',
                    title: 'User',
                    width: 500,
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                        ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="user-Photo" height="50" width="50">` : ` <div class="kt-badge kt-badge--xl kt-badge--info">  ${row.Name.substring(0, 1).toUpperCase()}</div>`}
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip"> ${row.Name} </span> 
                                    </div>
                               </div>`;
                    }
                },
                {
                    field: 'CoachNumber',
                    title: 'Coach Number',
                },
                {
                    field: 'ExpiryDate',
                    title: 'Expiry Date',
                    template: function (row) {
                        return moment(row.ExpiryDate).format('DD-MMM-YYYY');
                    }
                },
            ]
        });

        dataTable.on('click', 'tr', function () {
            const index = ($("tr").index(this) - 1);
            if (dataTable.dataSet[index]) {
                setCoachTagging(dataTable.dataSet[index]);
                setRightSideDetails(true);
            }
        });
    }

    const updateCoachTaggingDetails = (field, value) => {
        setCoachTagging((d) => {
            return { ...d, [field]: value };
        });
    }

    const addCoachTaggingHandler = async (e) => {
        e.preventDefault();

        const btn = $('#btnSave');
        var form = $('#add-coachTagging-form');

        form.validate({
            rules: {
                ddlUser: {
                    required: true,
                },
                txtCoachNumber: {
                    required: true
                },
                txtExpiryDate: {
                    required: true
                }
            },
            messages: {
                ddlUser: {
                    required: "Please select user"
                },
                txtCoachNumber: {
                    required: "Please enter coach number"
                },
                txtExpiryDate: {
                    required: "Please select expiry date"
                }
            }
        });

        if (!form.valid()) return;

        helper.StartProcessing(btn);

        try {
            await postCoachTagging(coachTagging);
            helper.StopProcessing(btn);

            if (coachTagging.ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Coach Tagging updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,
                    animation: false,
                    customClass: {
                        popup: 'margin-20',
                    },
                });
            } else {
                swal.fire({
                    icon: 'success',
                    titleText: 'Coach Tagging added successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            closeDrawer();
            fetchCoachTagging();

        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon: 'error',
                titleText: 'Error!',
                text: err.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
        }
    }

    const closeDrawer = () => {
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
        }, 200);
    }

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input type="text" className="form-control clientSearch" placeholder="Search Coach Tagging..." id="generalSearch" />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-wrapper">
                                    <div className="kt-portlet__head-actions">
                                        <button onClick={() => setRightSideDetails(true)} type="button" className="btn btn-brand btn-icon-sm text-white d-inline"><i className="la la-plus"></i>New Coach Tagging</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblCoachTagging" className="kt-datatable table-striped clickable"></div>
                            {rightSideDetails && <RightSideDetails title="Coach Tagging Details" onCloseDrawer={closeDrawer}>
                                <div className="kt-portlet">
                                    <div className="kt-portlet__body padding-t30 padding-b0">
                                        <form className="kt-form" id="add-coachTagging-form">
                                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">User <span className="red">*</span></label>
                                                    <div className="col-3">
                                                        <Select
                                                            value={usersList && usersList.length > 0 && coachTagging.UserID ? { label: usersList.find(m => m.ID === coachTagging.UserID).UserName, value: coachTagging.UserID } : null}
                                                            onChange={(event) => updateCoachTaggingDetails('UserID', event.value)}
                                                            name="ddlUser"
                                                            placeholder="Select User"
                                                            id="ddlUser"
                                                            isDisabled={coachTagging.ID}
                                                            className="ddlUser"
                                                            options={usersList.map(c => ({ label: c.UserName, value: c.ID }))}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Coach Number <span className="red">*</span></label>
                                                    <div className="col-xl-4 col-lg-6">
                                                        <input
                                                            id="txtCoachNumber"
                                                            name="txtCoachNumber"
                                                            type="text"
                                                            className="form-control"
                                                            value={coachTagging.CoachNumber || ''}
                                                            onChange={(event) => updateCoachTaggingDetails('CoachNumber', event.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Expiry Date <span className="red">*</span></label>
                                                    <div className="col-xl-4 col-lg-6">
                                                        <div className="input-group date">
                                                            <input
                                                                id="txtExpiryDate"
                                                                name="txtExpiryDate"
                                                                type="text"
                                                                className="form-control date-input"
                                                                readOnly={true}
                                                                placeholder="Select expiry date"
                                                                value={coachTagging.ExpiryDate ? moment(coachTagging.ExpiryDate).format('DD-MM-YYYY') : ''}
                                                            />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text">
                                                                    <i className="la la-calendar-check-o"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="kt-portlet__foot">
                                                    <div className="kt-form__actions">
                                                        <div className="row">
                                                            <div className="col-lg-9 ml-lg-auto">
                                                                <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addCoachTaggingHandler}>Save</button>
                                                                <button id="btnCancel" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </RightSideDetails>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CoachTagging;
